import init from '../../helpers/init';
import {showAlert} from '../main';

const {$} = init;
const BX = (<any>window).BX;

$(() => {
  const notificationsSocketComponent = BX.namespace('__pwd.NotificationsSocketComponent');
  const conn = new WebSocket(notificationsSocketComponent.addressUrl + notificationsSocketComponent.encode);

  conn.onopen = function (e) {
    keepAlive();
  };

  conn.onmessage = function (e) {
    const obj = jQuery.parseJSON(e.data);

    if (notificationsSocketComponent.typesNotify[obj.TYPE]
        && notificationsSocketComponent.typesNotify[obj.TYPE] !== 'undefined') {
      switch (obj.TYPE) {
        case 'AddToBookmarks':
          AddToBookmarks(obj);
          break;
        case 'AddMessageToChat':
          addMessageToChat(obj);
          break;
      }
    }

    const notificationsBlock = $('.navbar-icons .notification');
    const countBlock = notificationsBlock.find('>span');

    if (countBlock.length) {
      const notificationCurrent: number = +$('.navbar-icons .notification >span').html();
      countBlock.html((notificationCurrent + 1).toString());
    } else {
      notificationsBlock.append('<span>1</span>');
    }
  };

  function AddToBookmarks(obj: any) {
    renderAddToBookmarks(obj);
  }

  function renderAddToBookmarks(obj: any) {
    const notifications = $('div.notifications');
    let userPick = "";
    if (obj.FROM_USER_PIC && obj.FROM_USER_PIC !== null) {
      userPick = `style="background-image: url(${obj.FROM_USER_PIC})"`;
    }
    const element = `<div class="info-card hoverable bg-green-light">
    <div class="row info-card__body">
        <div class="col-12 col-lg-4">
            <a href="#" class="user-item">
                <div class="user-item__image" ${userPick}></div>
                <div class="user-item__body">
                    <div class="user-item__name">${obj.FROM_USER_NAME}</div>
                    <div class="user-item__post">${obj.FROM_USER_POS}</div>
                </div>
            </a>
        </div>
        <div class="col-12 col-lg-6 divider-lg">${obj.MESSAGE}</div>
        <div class="col-12 col-lg-2 divider-lg pe-0">
            <div class="icon-before">
                <svg width="21" height="21">
                    <use xlink:href="/local/.development/dist/ico/sprite.svg#calendar"></use>
                </svg>Сейчас</div>
        </div>
    </div>
    <span class="badge bg-primary">Новое</span>
</div>`;

    notifications.append(element);
  }

  function addMessageToChat(obj: any) {
    const chatId = $('.js-messages-list').data('id');
    const params = jQuery.parseJSON(obj.PARAMETERS);
    const messageId = params.messageId;
    const forChatId = params.stringChatId;

    const data = {
      messageId,
      chatId,
      forChatId
    };

    BX.ajax.runComponentAction('pwd:chat.new', 'getMessage', {
      data,
      mode: 'class'
    }).then((result: any) => {
      if (result.data !== false) {
        const lastMessage = result.data;
        if (lastMessage.message) {
          const myMessageClass = lastMessage.isMine ? 'my-message' : '';
          $('.js-messages-list').append(`<div class="chat-list__message">
                    <div class="chat-message js-chat-message-item ${myMessageClass}">
                        <div class="chat-message__text js-chat-message-item-text">${lastMessage.message}</div>
                        <div class="chat-message__caption">
                            <div class="chat-message__date">${lastMessage.createdAtFormat}</div>
                            <div class="chat-message__author">${lastMessage.senderName}${lastMessage.addedText}</div>
                        </div>
                        <div class="chat-message__translate js-chat-message__translate${isChatLangSelectSocket() ? " active" : ""}">
                            <a
                                href="javascript:;"
                                class="chat-message__translate-link js-chat-message__translate-link"
                                data-id="${lastMessage.id}"
                            >${BX.message('LANGUAGE_ID') === 'en' ? 'Translate' : 'Перевести'}</a>
                            <div
                                class="chat-message__translate-result js-chat-message__translate-result"
                            ></div>
                        </div>
                    </div>
                </div>`);
          $('.js-chat-scroll').each(function() {
            scrollChatBand(this);
          });
        }
      }
    }).catch((err: any) => {
    });
  }

  conn.onclose = function (event) {
    cancelKeepAlive();
  };

  conn.onerror = function (error) {
    cancelKeepAlive();
  };

  let timerID = 0;

  function keepAlive() {
    const timeout = 20000;
    if (conn.readyState === conn.OPEN) {
      conn.send('');
    }
    timerID = window.setTimeout(keepAlive, timeout);
  }

  function cancelKeepAlive() {
    if (timerID) {
      window.clearTimeout(timerID);
    }
  }

  function isChatLangSelectSocket(){
    if($('.js-chat-lang-source').length
      && $('.js-chat-lang-target').length
      && $('.js-chat-lang-target').val()
      && $('.js-chat-lang-source').val()
    ){
      return true;
    }
    return false;
  }

  function scrollChatBand(element: HTMLElement) {
    const wrap = $(element);
    const band = wrap.find('.chat-list');
    const scroll = band.outerHeight() - wrap.outerHeight();
    wrap.animate({
      scrollTop: scroll
    }, 300, () => {
      wrap.find('.chat-preloader').remove();
    });
  }
});
